<div class="container-fluid pl-0 mt-3">
    <div class="row">
        <div class="col">
            <h6>{{ 'compactprojectlist.title' | trans }}</h6>
        </div>
    </div>
    <div  class="row">
<div *ngFor="let proj of allProjectsList" class="col-md-6 col-lg-4">
    <div class="card bg-secondary mb-2 h-55">
        <div class="card-body pt-2 pb-2 pl-3 pr-3">
            <div class="row">
                <div class="col-1 mr-3">
                    <app-customerlogo [customerId]="proj.customer" ></app-customerlogo>
                </div>
                <div class="col">
                    <p class="mb-0 align-middle lh-35 text-truncate" style="min-width:10vh; max-width: 25vh;" matTooltip="{{proj.title}}" matTooltipPosition="above" matTooltipShowDelay="500">{{proj.title}}</p>
                </div>
                <div class="col- pr-2 " style="margin-top: -8px;">
                  <ng-container *ngIf="proj.overduedays == 0 && proj.progress == 0">
                    <div style="margin-top:4px; margin-right: 3px;">
                      <circle-progress
                      [percent]="proj.progress"
                      [radius]="18"
                      [outerStrokeWidth]="0"
                      [titleFontSize]="12"
                      [titleFontWeight]="700"
                      [subtitleFontSize]="0"
                      [outerStrokeColor]="'#ccc'"
                      [titleColor]="'#ccc'"
                      [animation]="true"
                      [animationDuration]="100"
                      [unitsFontSize]="12"
                      [unitsFontWeight]="700"
                      [unitsColor]="'#ccc'"
                    ></circle-progress>
                    </div>
                  </ng-container>
                    <circle-progress *ngIf="proj.overduedays == 0 && proj.progress < 100 && proj.progress != 0 "
                    [percent]="proj.progress"
                    [radius]="18"
                    [outerStrokeWidth]="3"
                    [titleFontSize]="12"
                    [subtitleFontSize]="0"
                    [outerStrokeColor]="'#43aa8b'"
                    [titleColor]="'#43aa8b'"
                    [animation]="true"
                    [animationDuration]="100"
                    [unitsFontSize]="12"
                    [unitsColor]="'#43aa8b'"
                  ></circle-progress>
                  <ng-container *ngIf="proj.overduedays == 0 && proj.progress == 100">
                    <div style="margin-top:8px; margin-right:5px;">
                      <circle-progress 
                      [percent]="proj.progress"
                      [radius]="18"
                      [titleFontSize]="12"
                      [subtitleFontSize]="0"
                      [titleFontWeight]="700"
                      [titleColor]="'#43aa8b'"
                      [outerStrokeWidth]="0"
                      [animation]="true"
                      [animationDuration]="100"
                      [unitsFontSize]="12"
                      [unitsColor]="'#43aa8b'"
                      [unitsFontWeight]="700"
                      [backgroundPadding]="1"
                    ></circle-progress>
                    </div>
                  </ng-container>
                  <circle-progress *ngIf="proj.overduedays > 0 && proj.overduedays <= 3"
                    [percent]="proj.progress"
                    [radius]="18"
                    [outerStrokeWidth]="3"
                    [titleFontSize]="12"
                    [subtitleFontSize]="0"
                    [outerStrokeColor]="'yellow'"
                    [titleColor]="'yellow'"
                    [animation]="true"
                    [animationDuration]="100"
                    [unitsFontSize]="12"
                    [unitsColor]="'yellow'"
                  ></circle-progress>
                  <circle-progress *ngIf="proj.overduedays > 3 && proj.progress > 0"
                    [percent]="proj.progress"
                    [radius]="18"
                    [outerStrokeWidth]="3"
                    [titleFontSize]="12"
                    [subtitleFontSize]="0"
                    [outerStrokeColor]="'#ef3054'"
                    [titleColor]="'#ef3054'"
                    [animation]="true"
                    [animationDuration]="100"
                    [unitsFontSize]="12"
                    [unitsColor]="'#ef3054'"
                  ></circle-progress>
                  <ng-container *ngIf="proj.overduedays > 3 && proj.progress == 0">
                    <div  style="margin-top:6px; margin-right:5px;">
                      <circle-progress  
                      [percent]="proj.progress"
                      [radius]="16"
                      [outerStrokeWidth]="3"
                      [titleFontSize]="15"
                      [subtitleFontSize]="0"
                      [outerStrokeColor]="'#ef3054'"
                      [titleColor]="'white'"
                      [animation]="true"
                      [animationDuration]="100"
                      [unitsFontSize]="15"
                      [unitsColor]="'white'"
                      [backgroundColor]="'#ef3054'"
                      [backgroundPadding]="1"
                    ></circle-progress>
                    </div>
                  </ng-container>
                </div>
                <!----
                <div class="col-" style="margin-top:5px;">
                    <div class="dropdown">
                        <button class="btn-empty border-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="material-icons">
                                more_horiz
                              </span>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a class="dropdown-item" href="#">Action</a>
                          <a class="dropdown-item" href="#">Another action</a>
                          <a class="dropdown-item" href="#">Something else here</a>
                        </div>
                      </div>
                </div>
                  ---->
            </div>
        </div>
    </div>
</div>



</div>
</div>